import React from 'react';
import { Alert, Box, Tabs, Text, ThemeIcon } from '@mantine/core';
import { IconCalculator, IconFileDescription, IconInfoCircle, IconReportMoney } from '@tabler/icons-react';
import type { ICotizacionServicios } from '../../../../modelos/CotizadorServicios/entidades/ICotizacionServicios';
import { ResumenComercialVista } from '../resumenComercialVista';
import { DesgloseInternoVista } from '../desgloseInternoVista';

interface PasoResumenVistaProps {
    cotizacion: ICotizacionServicios;
    nombrePais?: string;
    porcentajeIva: number;
    /** El cálculo es anterior al último cambio de datos o equipos. */
    requiereRecalculo: boolean;
}

/** Paso 3: resumen comercial (cliente) y desglose interno de costos. */
export const PasoResumenVista: React.FC<PasoResumenVistaProps> = ({ cotizacion, nombrePais, porcentajeIva, requiereRecalculo }) => {
    if (!cotizacion.Resultado) {
        return (
            <Box p="xl" ta="center">
                <ThemeIcon size={64} radius="xl" color="gray" variant="light" mb="md">
                    <IconCalculator size={32} />
                </ThemeIcon>
                <Text c="dimmed">Presiona "Calcular Cotización" para ver los resultados.</Text>
            </Box>
        );
    }

    return (
        <>
            {requiereRecalculo && (
                <Alert color="yellow" variant="light" icon={<IconInfoCircle size={16} />} mb="md">
                    Hay cambios después del último cálculo. Recalcula la cotización para actualizar los valores.
                </Alert>
            )}
            <Tabs defaultValue="comercial">
                <Tabs.List mb="md">
                    <Tabs.Tab value="comercial" leftSection={<IconFileDescription size={14} />}>Resumen Comercial</Tabs.Tab>
                    <Tabs.Tab value="interno" leftSection={<IconReportMoney size={14} />}>Desglose Interno</Tabs.Tab>
                </Tabs.List>
                <Tabs.Panel value="comercial">
                    <ResumenComercialVista cotizacion={cotizacion} resultado={cotizacion.Resultado} nombrePais={nombrePais} porcentajeIva={porcentajeIva} />
                </Tabs.Panel>
                <Tabs.Panel value="interno">
                    <DesgloseInternoVista resultado={cotizacion.Resultado} />
                </Tabs.Panel>
            </Tabs>
        </>
    );
};
